import styled from '@emotion/styled'

import { useTheme } from '@emotion/react'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import FooterCompact from '@segment/templates/FooterCompact'
import NavigationBrand from '@segment/templates/NavigationBrand'
import GettingStarted from '@segment/templates/GettingStarted'
import DividerSection from '@segment/templates/DividerSection'

import { usePageConfig } from '@segment/contexts/page'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'
import ResourcesSection from './components/ResourcesSection'

import data from './data'

const copy = {
  pageTitle: `Customer Data Maturity Resource Accompaniment | Twilio Segment`,
  pageDescription: `To help guide you through this book, we’ve collected a series of resources to aid you on your customer data journey.`,
}

const CustomerDataMaturityResourcesView = () => {
  const theme = useTheme()
  const pageConfig = usePageConfig()

  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle={copy.pageTitle}
        pageDescription={copy.pageDescription}
        bodyBackground={theme.palette.neutrals.white[100]}
      >
        <NavigationBrand />
        <Main>
          <Hero />
          {data(pageConfig).map(({ title, resources }, index) => (
            <div key={title}>
              <ResourcesSection title={title} resources={resources} />

              {index + 1 !== data.length && <DividerSection />}
            </div>
          ))}
          <GettingStarted />
        </Main>
        <FooterCompact />
      </Layout>
    </AppearanceProvider>
  )
}

const Main = styled.main`
  background-color: ${({ theme }) => theme.palette.neutrals.white[100]};
`

export default CustomerDataMaturityResourcesView
